import React from 'react';
const SendInviteIcon = (props) => (
  <svg width='32px' height='32px' viewBox='0 0 32 32' {...props}>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g fill='currentColor'>
        <polygon points='5 6.83333333 27 16.4583333 5 25.1666667 4.999 17.8433333 16 16.125 4.999 14.1763333' />
      </g>
    </g>
  </svg>
);

export default SendInviteIcon;
